import { FiltersProps, ResourceProps } from '@/app/models/new-resource'
import { Actions } from '../actions/new-resource'

export interface NewResourceState {
    documents: ResourceProps[]
    forms: ResourceProps[]
    totalDocuments: number
    totalForms: number
    loading: boolean
    filters: FiltersProps
    smartFilter: any
}

export const NEW_RESOURCE_REDUCER_NAMESPACE = 'newResourceReducer'

let defaultstate: any = {
    documents: [],
    forms: [],
    totalDocuments: 0,
    totalForms: 0,
    loading: true,
    loadingFolders: false,
    filters: {
        page: 1,
        page_size: -1,
        first: 0,
        rows: -1,
        sortingType: null,
    },
    storeList: [],
    visibility: [],
    description: '',
    title: '',
    url: '',
    smartFilter: {},
    documentsApiFullfilled: false
}

export default (state = defaultstate, action) => {
    switch (action.type) {
        case Actions.GET_FOLDER_DETAILS_REQUEST: {
            return {
                ...state,
                loadingFolders: true,
            }
        }

        case Actions.GET_FOLDER_DETAILS_SUCCESS: {
            return {
                ...state,
                loadingFolders: false,
            }
        }

        case Actions.GET_FOLDER_DETAILS_FAILURE: {
            return {
                ...state,
                loadingFolders: false,
            }
        }

        case Actions.GET_DOCUMENTS_REQUEST: {
            return {
                ...state,
                loading: true,
                documentsApiFullfilled: false
            }
        }
        case Actions.GET_DOCUMENTS_SUCCESS:
            return {
                ...state,
                documents: action.documents,
                totalDocuments: action.totalDocuments,
                loading: false,
                documentsApiFullfilled: true
            }
        case Actions.GET_DOCUMENTS_FAILURE:
            return {
                ...state,
                loading: false,
                documentsApiFullfilled: true
            }
        case Actions.GET_FORMS_REQUEST: {
            return {
                ...state,
                loading: true,
            }
        }
        case Actions.GET_FORMS_SUCCESS:
            return {
                ...state,
                forms: action.forms,
                totalForms: action.totalForms,
                loading: false,
            }
        case Actions.GET_FORMS_FAILURE:
            return {
                ...state,
                loading: false,
            }
        case Actions.GET_LINKS_REQUEST: {
            return {
                ...state,
                loading: true,
            }
        }
        case Actions.GET_LINKS_SUCCESS:
            return {
                ...state,
                links: action.links,
                totalLinks: action.totalLinks,
                loading: false,
            }
        case Actions.GET_LINKS_FAILURE:
            return {
                ...state,
                loading: false,
            }

        case Actions.GET_LINKS_REQUEST_ID: {
            return {
                ...state,
                loading: true,
            }
        }
        case Actions.GET_LINKS_SUCCESS_ID:
            return {
                ...state,
                title: action.title,
                description: action.description,
                url: action.url,
                visibility: action.visibility,
                storeList: action.storeList,
                loading: false,
            }
        case Actions.GET_LINKS_FAILURE_ID:
            return {
                ...state,
                loading: false,
            }
        case Actions.SET_SMART_FILTER:
            return {
                ...state,
                smartFilter: action.value,
            }
        case Actions.COPY_LINK_TO_CLIPBOARD_SUCCESS:
            return {
                ...state,
                toastList: action.toastList,
            }
        default:
            return state
    }
}
